/**
 * One place that decides what a campaign card shows. The API sends
 * overall_progress, but if it is missing or stale we work it out from the
 * money itself so a bar never sits at 0% while gifts are in.
 */
export const campaignProgress = (c = {}) => {
  const raised = Number(c.raised_amount ?? c.current_amount ?? 0) || 0;
  const target = Number(c.target_amount ?? c.goal_amount ?? 0) || 0;
  const fromApi = Number(c.overall_progress ?? 0) || 0;
  const computed = target > 0 ? (raised / target) * 100 : 0;
  const pct = Math.min(100, fromApi > 0 ? fromApi : computed);
  return {
    raised,
    target,
    pct,
    // sub-1% still deserves an honest number rather than a flat zero
    label: pct > 0 && pct < 1 ? '<1%' : `${Math.round(pct)}%`,
    needsTarget: target <= 0,
    currency: (c.currency || 'USD').toUpperCase(),
  };
};

export const money = (amount, currency = 'USD') =>
  `${currency} ${Number(amount || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
